<template lang="html">
<div class="voiceNames">
    <div class="Vlt-form__element">
        <div v-if="mysel" class="Vlt-composite">
            <div class="Vlt-composite__prepend">
                <div class="Vlt-native-dropdown">
                    <select v-model="lang" @change="newLang($event)">
                        <option v-for="language in ulang" :value="language">{{ language }}</option>
                    </select>
                </div>
            </div>
            <div class="Vlt-composite__append">
                <div class="Vlt-native-dropdown">
                    <select v-model="sel" @change="newSel($event)">
                        <option v-for="voice in svoices" :value="voice.voice">{{ voice.voice }} ({{ voice.gender }} {{voice.language}})</option>
                    </select>
                </div>
            </div>
        </div>
        <div v-else class="Vlt-composite">
            <div class="Vlt-composite__prepend">
                <div class="Vlt-native-dropdown">
                    <select v-model="lang" @change="gotLang($event)">
                        <option v-for="(val,language) in newVoices" :value="language">{{ language }} ({{val[0].code}})</option>
                    </select>
                </div>
            </div>
            <div class="Vlt-composite__append">
                <div class="Vlt-native-dropdown">
                    <select v-model="curStyle" @change="gotStyle($event)">
                        <option v-for="style in styles" :value="style.style">Style: {{ style.style }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script lang="js">
export default {
    name: 'voiceNames',
    props: {
        mysel: {
            type: String,
            required: false
        },
        myVoice: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            defaultVoice: {
                code: 'en-US',
                style: 0
            },
            curVoice: {},
            newVoices: { //https://raw.githubusercontent.com/nexmo-community/vapi-tts-voices/main/voices.json
                "Arabic": [{
                        "code": "ar",
                        "style": 0
                    },
                    {
                        "code": "ar",
                        "style": 1
                    },
                    {
                        "code": "ar",
                        "style": 2
                    },
                    {
                        "code": "ar",
                        "style": 3
                    },
                    {
                        "code": "ar",
                        "style": 4
                    },
                    {
                        "code": "ar",
                        "style": 5
                    },
                    {
                        "code": "ar",
                        "style": 6
                    },
                    {
                        "code": "ar",
                        "style": 7
                    }
                ],
                "Basque": [{
                    "code": "eu-ES",
                    "style": 0
                }],
                "Bengali": [{
                        "code": "bn-IN",
                        "style": 0
                    },
                    {
                        "code": "bn-IN",
                        "style": 1
                    }
                ],
                "Catalan, Valencian": [{
                        "code": "ca-ES",
                        "style": 0
                    },
                    {
                        "code": "ca-ES",
                        "style": 1
                    }
                ],
                "Chinese, Cantonese": [{
                    "code": "yue-CN",
                    "style": 0
                }],
                "Chinese, Mandarin": [{
                        "code": "cmn-CN",
                        "style": 0
                    },
                    {
                        "code": "cmn-CN",
                        "style": 1
                    },
                    {
                        "code": "cmn-CN",
                        "style": 2
                    },
                    {
                        "code": "cmn-CN",
                        "style": 3
                    },
                    {
                        "code": "cmn-CN",
                        "style": 4
                    },
                    {
                        "code": "cmn-CN",
                        "style": 5
                    }
                ],
                "Chinese, Mandarin (Taiwan)": [{
                        "code": "cmn-TW",
                        "style": 0
                    },
                    {
                        "code": "cmn-TW",
                        "style": 1
                    },
                    {
                        "code": "cmn-TW",
                        "style": 2
                    },
                    {
                        "code": "cmn-TW",
                        "style": 3
                    }
                ],
                "Czech": [{
                        "code": "cs-CZ",
                        "style": 0
                    },
                    {
                        "code": "cs-CZ",
                        "style": 1
                    },
                    {
                        "code": "cs-CZ",
                        "style": 2
                    }
                ],
                "Danish": [{
                        "code": "da-DK",
                        "style": 0
                    },
                    {
                        "code": "da-DK",
                        "style": 1
                    },
                    {
                        "code": "da-DK",
                        "style": 2
                    },
                    {
                        "code": "da-DK",
                        "style": 3
                    },
                    {
                        "code": "da-DK",
                        "style": 4
                    },
                    {
                        "code": "da-DK",
                        "style": 5
                    }
                ],
                "Dutch": [{
                        "code": "nl-NL",
                        "style": 0
                    },
                    {
                        "code": "nl-NL",
                        "style": 1
                    },
                    {
                        "code": "nl-NL",
                        "style": 2
                    },
                    {
                        "code": "nl-NL",
                        "style": 3
                    },
                    {
                        "code": "nl-NL",
                        "style": 4
                    },
                    {
                        "code": "nl-NL",
                        "style": 5
                    },
                    {
                        "code": "nl-NL",
                        "style": 6
                    }
                ],
                "English (Australia)": [{
                        "code": "en-AU",
                        "style": 0
                    },
                    {
                        "code": "en-AU",
                        "style": 1
                    },
                    {
                        "code": "en-AU",
                        "style": 2
                    },
                    {
                        "code": "en-AU",
                        "style": 3
                    },
                    {
                        "code": "en-AU",
                        "style": 4
                    },
                    {
                        "code": "en-AU",
                        "style": 5
                    }
                ],
                "English (India)": [{
                        "code": "en-IN",
                        "style": 0
                    },
                    {
                        "code": "en-IN",
                        "style": 1
                    },
                    {
                        "code": "en-IN",
                        "style": 2
                    },
                    {
                        "code": "en-IN",
                        "style": 3
                    },
                    {
                        "code": "en-IN",
                        "style": 4
                    },
                    {
                        "code": "en-IN",
                        "style": 5
                    }
                ],
                "English (South Africa)": [{
                    "code": "en-ZA",
                    "style": 0
                }],
                "English (United Kingdom)": [{
                        "code": "en-GB",
                        "style": 0
                    },
                    {
                        "code": "en-GB",
                        "style": 1
                    },
                    {
                        "code": "en-GB",
                        "style": 2
                    },
                    {
                        "code": "en-GB",
                        "style": 3
                    },
                    {
                        "code": "en-GB",
                        "style": 4
                    },
                    {
                        "code": "en-GB",
                        "style": 5
                    },
                    {
                        "code": "en-GB",
                        "style": 6
                    },
                    {
                        "code": "en-GB",
                        "style": 7
                    }
                ],
                "English (United States)": [{
                        "code": "en-US",
                        "style": 0
                    },
                    {
                        "code": "en-US",
                        "style": 1
                    },
                    {
                        "code": "en-US",
                        "style": 2
                    },
                    {
                        "code": "en-US",
                        "style": 3
                    },
                    {
                        "code": "en-US",
                        "style": 4
                    },
                    {
                        "code": "en-US",
                        "style": 5
                    },
                    {
                        "code": "en-US",
                        "style": 6
                    },
                    {
                        "code": "en-US",
                        "style": 7
                    },
                    {
                        "code": "en-US",
                        "style": 8
                    },
                    {
                        "code": "en-US",
                        "style": 9
                    },
                    {
                        "code": "en-US",
                        "style": 10
                    },
                    {
                        "code": "en-US",
                        "style": 11
                    }
                ],
                "English (Wales)": [{
                    "code": "en-GB-WLS",
                    "style": 0
                }],
                "Filipino": [{
                        "code": "fil-PH",
                        "style": 0
                    },
                    {
                        "code": "fil-PH",
                        "style": 1
                    },
                    {
                        "code": "fil-PH",
                        "style": 2
                    },
                    {
                        "code": "fil-PH",
                        "style": 3
                    }
                ],
                "Finnish": [{
                        "code": "fi-FI",
                        "style": 0
                    },
                    {
                        "code": "fi-FI",
                        "style": 1
                    }
                ],
                "French (Canada)": [{
                        "code": "fr-CA",
                        "style": 0
                    },
                    {
                        "code": "fr-CA",
                        "style": 1
                    },
                    {
                        "code": "fr-CA",
                        "style": 2
                    },
                    {
                        "code": "fr-CA",
                        "style": 3
                    },
                    {
                        "code": "fr-CA",
                        "style": 4
                    }
                ],
                "French (France)": [{
                        "code": "fr-FR",
                        "style": 0
                    },
                    {
                        "code": "fr-FR",
                        "style": 1
                    },
                    {
                        "code": "fr-FR",
                        "style": 2
                    },
                    {
                        "code": "fr-FR",
                        "style": 3
                    },
                    {
                        "code": "fr-FR",
                        "style": 4
                    },
                    {
                        "code": "fr-FR",
                        "style": 5
                    },
                    {
                        "code": "fr-FR",
                        "style": 6
                    },
                    {
                        "code": "fr-FR",
                        "style": 7
                    }
                ],
                "German": [{
                        "code": "de-DE",
                        "style": 0
                    },
                    {
                        "code": "de-DE",
                        "style": 1
                    },
                    {
                        "code": "de-DE",
                        "style": 2
                    },
                    {
                        "code": "de-DE",
                        "style": 3
                    },
                    {
                        "code": "de-DE",
                        "style": 4
                    },
                    {
                        "code": "de-DE",
                        "style": 5
                    },
                    {
                        "code": "de-DE",
                        "style": 6
                    }
                ],
                "Greek": [{
                        "code": "el-GR",
                        "style": 0
                    },
                    {
                        "code": "el-GR",
                        "style": 1
                    },
                    {
                        "code": "el-GR",
                        "style": 2
                    }
                ],
                "Hebrew": [{
                    "code": "he-IL",
                    "style": 0
                }],
                "Hindi": [{
                        "code": "hi-IN",
                        "style": 0
                    },
                    {
                        "code": "hi-IN",
                        "style": 1
                    },
                    {
                        "code": "hi-IN",
                        "style": 2
                    }
                ],
                "Hungarian": [{
                        "code": "hu-HU",
                        "style": 0
                    },
                    {
                        "code": "hu-HU",
                        "style": 1
                    }
                ],
                "Icelandic": [{
                        "code": "is-IS",
                        "style": 0
                    },
                    {
                        "code": "is-IS",
                        "style": 1
                    }
                ],
                "Indonesian": [{
                        "code": "id-ID",
                        "style": 0
                    },
                    {
                        "code": "id-ID",
                        "style": 1
                    },
                    {
                        "code": "id-ID",
                        "style": 2
                    },
                    {
                        "code": "id-ID",
                        "style": 3
                    },
                    {
                        "code": "id-ID",
                        "style": 4
                    }
                ],
                "Italian": [{
                        "code": "it-IT",
                        "style": 0
                    },
                    {
                        "code": "it-IT",
                        "style": 1
                    },
                    {
                        "code": "it-IT",
                        "style": 2
                    },
                    {
                        "code": "it-IT",
                        "style": 3
                    },
                    {
                        "code": "it-IT",
                        "style": 4
                    },
                    {
                        "code": "it-IT",
                        "style": 5
                    },
                    {
                        "code": "it-IT",
                        "style": 6
                    }
                ],
                "Japanese": [{
                        "code": "ja-JP",
                        "style": 0
                    },
                    {
                        "code": "ja-JP",
                        "style": 1
                    },
                    {
                        "code": "ja-JP",
                        "style": 2
                    },
                    {
                        "code": "ja-JP",
                        "style": 3
                    },
                    {
                        "code": "ja-JP",
                        "style": 4
                    },
                    {
                        "code": "ja-JP",
                        "style": 5
                    }
                ],
                "Korean": [{
                        "code": "ko-KR",
                        "style": 0
                    },
                    {
                        "code": "ko-KR",
                        "style": 1
                    },
                    {
                        "code": "ko-KR",
                        "style": 2
                    },
                    {
                        "code": "ko-KR",
                        "style": 3
                    },
                    {
                        "code": "ko-KR",
                        "style": 4
                    },
                    {
                        "code": "ko-KR",
                        "style": 5
                    }
                ],
                "Malayalam": [{
                        "code": "ml-IN",
                        "style": 0
                    },
                    {
                        "code": "ml-IN",
                        "style": 1
                    }
                ],
                "Norwegian": [{
                        "code": "no-NO",
                        "style": 0
                    },
                    {
                        "code": "no-NO",
                        "style": 1
                    }
                ],
                "Norwegian Bokmål": [{
                        "code": "nb-NO",
                        "style": 0
                    },
                    {
                        "code": "nb-NO",
                        "style": 1
                    },
                    {
                        "code": "nb-NO",
                        "style": 2
                    },
                    {
                        "code": "nb-NO",
                        "style": 3
                    },
                    {
                        "code": "nb-NO",
                        "style": 4
                    },
                    {
                        "code": "nb-NO",
                        "style": 5
                    }
                ],
                "Polish": [{
                        "code": "pl-PL",
                        "style": 0
                    },
                    {
                        "code": "pl-PL",
                        "style": 1
                    },
                    {
                        "code": "pl-PL",
                        "style": 2
                    },
                    {
                        "code": "pl-PL",
                        "style": 3
                    },
                    {
                        "code": "pl-PL",
                        "style": 4
                    },
                    {
                        "code": "pl-PL",
                        "style": 5
                    },
                    {
                        "code": "pl-PL",
                        "style": 6
                    },
                    {
                        "code": "pl-PL",
                        "style": 7
                    },
                    {
                        "code": "pl-PL",
                        "style": 8
                    }
                ],
                "Portuguese (Brazil)": [{
                        "code": "pt-BR",
                        "style": 0
                    },
                    {
                        "code": "pt-BR",
                        "style": 1
                    },
                    {
                        "code": "pt-BR",
                        "style": 2
                    },
                    {
                        "code": "pt-BR",
                        "style": 3
                    },
                    {
                        "code": "pt-BR",
                        "style": 4
                    },
                    {
                        "code": "pt-BR",
                        "style": 5
                    }
                ],
                "Portuguese (Portugal)": [{
                        "code": "pt-PT",
                        "style": 0
                    },
                    {
                        "code": "pt-PT",
                        "style": 1
                    },
                    {
                        "code": "pt-PT",
                        "style": 2
                    },
                    {
                        "code": "pt-PT",
                        "style": 3
                    },
                    {
                        "code": "pt-PT",
                        "style": 4
                    },
                    {
                        "code": "pt-PT",
                        "style": 5
                    },
                    {
                        "code": "pt-PT",
                        "style": 6
                    },
                    {
                        "code": "pt-PT",
                        "style": 7
                    }
                ],
                "Romanian": [{
                        "code": "ro-RO",
                        "style": 0
                    },
                    {
                        "code": "ro-RO",
                        "style": 1
                    }
                ],
                "Russian": [{
                        "code": "ru-RU",
                        "style": 0
                    },
                    {
                        "code": "ru-RU",
                        "style": 1
                    },
                    {
                        "code": "ru-RU",
                        "style": 2
                    },
                    {
                        "code": "ru-RU",
                        "style": 3
                    },
                    {
                        "code": "ru-RU",
                        "style": 4
                    },
                    {
                        "code": "ru-RU",
                        "style": 5
                    },
                    {
                        "code": "ru-RU",
                        "style": 6
                    }
                ],
                "Slovak": [{
                        "code": "sk-SK",
                        "style": 0
                    },
                    {
                        "code": "sk-SK",
                        "style": 1
                    }
                ],
                "Spanish (Mexico)": [{
                    "code": "es-MX",
                    "style": 0
                }],
                "Spanish (Spain)": [{
                        "code": "es-ES",
                        "style": 0
                    },
                    {
                        "code": "es-ES",
                        "style": 1
                    },
                    {
                        "code": "es-ES",
                        "style": 2
                    },
                    {
                        "code": "es-ES",
                        "style": 3
                    },
                    {
                        "code": "es-ES",
                        "style": 4
                    }
                ],
                "Spanish (United States)": [{
                        "code": "es-US",
                        "style": 0
                    },
                    {
                        "code": "es-US",
                        "style": 1
                    },
                    {
                        "code": "es-US",
                        "style": 2
                    }
                ],
                "Swedish": [{
                        "code": "sv-SE",
                        "style": 0
                    },
                    {
                        "code": "sv-SE",
                        "style": 1
                    },
                    {
                        "code": "sv-SE",
                        "style": 2
                    },
                    {
                        "code": "sv-SE",
                        "style": 3
                    }
                ],
                "Tamil": [{
                        "code": "ta-IN",
                        "style": 0
                    },
                    {
                        "code": "ta-IN",
                        "style": 1
                    }
                ],
                "Telugu": [{
                        "code": "te-IN",
                        "style": 0
                    },
                    {
                        "code": "te-IN",
                        "style": 1
                    }
                ],
                "Thai": [{
                        "code": "th-TH",
                        "style": 0
                    },
                    {
                        "code": "th-TH",
                        "style": 1
                    }
                ],
                "Turkish": [{
                        "code": "tr-TR",
                        "style": 0
                    },
                    {
                        "code": "tr-TR",
                        "style": 1
                    },
                    {
                        "code": "tr-TR",
                        "style": 2
                    },
                    {
                        "code": "tr-TR",
                        "style": 3
                    },
                    {
                        "code": "tr-TR",
                        "style": 4
                    },
                    {
                        "code": "tr-TR",
                        "style": 5
                    },
                    {
                        "code": "tr-TR",
                        "style": 6
                    },
                    {
                        "code": "tr-TR",
                        "style": 7
                    }
                ],
                "Ukrainian": [{
                    "code": "uk-UA",
                    "style": 0
                }],
                "Vietnamese": [{
                        "code": "vi-VN",
                        "style": 0
                    },
                    {
                        "code": "vi-VN",
                        "style": 1
                    },
                    {
                        "code": "vi-VN",
                        "style": 2
                    },
                    {
                        "code": "vi-VN",
                        "style": 3
                    }
                ],
                "Welsh": [{
                    "code": "cy-GB",
                    "style": 0
                }]
            },
            voices: ["Salli", "Joey", "Naja", "Mads", "Marlene", "Hans", "Nicole", "Russell", "Amy", "Brian", "Emma", "Gwyneth", "Geraint", "Gwyneth", "Geraint", "Raveena", "Ivy", "Justin", "Kendra", "Kimberly", "Joanna", "Conchita", "Enrique", "Penelope", "Miguel", "Chantal", "Celine", "Mathieu", "Aditi", "Dora", "Karl", "Carla", "Giorgio", "Liv", "Lotte", "Ruben", "Jacek", "Ewa", "Jan", "Maja", "Vitoria", "Ricardo", "Cristiano", "Ines", "Carmen", "Maxim", "Tatyana", "Astrid", "Filiz", "Mizuki", "Seoyeon", "Laila", "Maged", "Tarik", "Damayanti", "Miren", "Sin-Ji", "Jordi", "Montserrat", "Iveta", "Zuzana", "Tessa", "Satu", "Melina", "Nikos", "Carmit", "Lekha", "Mariska", "Sora", "Tian-Tian", "Mei-Jia", "Nora", "Henrik", "Luciana", "Felipe", "Catarina", "Joana", "Ioana", "Laura", "Alva", "Oskar", "Kanya", "Cem", "Yelda", "Empar"],
            languages: ["en-US", "en-US", "da-DK", "da-DK", "de-DE", "de-DE", "en-AU", "en-AU", "en-GB", "en-GB", "en-GB", "en-GB", "en-GB", "cy-GB", "cy-GB", "en-IN", "en-US", "en-US", "en-US", "en-US", "en-US", "es-ES", "es-ES", "es-US", "es-US", "fr-CA", "fr-FR", "fr-FR", "hi-IN", "is-IS", "is-IS", "it-IT", "it-IT", "nb-NO", "nl-NL", "nl-NL", "pl-PL", "pl-PL", "pl-PL", "pl-PL", "pt-BR", "pt-BR", "pt-PT", "pt-PT", "ro-RO", "ru-RU", "ru-RU", "sv-SE", "tr-TR", "ja-JP", "ko-KR", "ara-XWW", "ara-XWW", "ara-XWW", "ind-IDN", "baq-ESP", "yue-CHN", "cat-ESP", "cat-ESP", "ces-CZE", "ces-CZE", "eng-ZAF", "fin-FIN", "ell-GRC", "ell-GRC", "heb-ISR", "hin-IND", "hun-HUN", "kor-KOR", "cmn-CHN", "cmn-TWN", "nor-NOR", "nor-NOR", "por-BRA", "por-BRA", "por-PRT", "por-PRT", "ron-ROU", "slk-SVK", "swe-SWE", "swe-SWE", "tha-THA", "tur-TUR", "tur-TUR", "spa-ESP"],
            genders: ["female", "male", "female", "male", "female", "male", "female", "male", "female", "male", "female", "WLS female", "WLS male", "WLS female", "WLS male", "female", "female", "male", "female", "female", "female", "female", "male", "female", "male", "female", "female", "male", "female", "female", "male", "female", "male", "female", "female", "male", "male", "female", "male", "female", "female", "male", "male", "female", "female", "male", "female", "female", "female", "female", "female", "female", "male", "male", "female", "female", "female", "male", "female", "female", "female", "female", "female", "female", "male", "female", "female", "female", "female", "female", "female", "female", "male", "female", "male", "female", "female", "female", "female", "female", "male", "female", "male", "female", "female"],
            ulang: [],
            lang: 'All Languages',
            svoices: [],
            sel: '',
            curStyle: 0,
            styles: [],
        }
    },
    methods: {
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        },
        filterVoices(lang) {
            this.svoices = [];
            if (lang != "All Languages") {
                this.sel = '';
            }
            for (var index = 0; index < this.languages.length; ++index) {
                if (lang == "All Languages" || lang == this.languages[index]) {
                    this.svoices.push({
                        voice: this.voices[index],
                        gender: this.genders[index],
                        language: this.languages[index]
                    });
                    if (!this.sel) {
                        this.sel = this.voices[index];
                        this.$emit('updated', this.sel);
                    }
                }
            }
        },
        newLang(event) {
            this.filterVoices(event.target.value);
        },
        newSel: function (event) {
            this.$emit('updated', event.target.value);
        },
        gotLang(event) {
            console.log("gotLang: " + event.target.value);
            this.styles = this.newVoices[event.target.value];
            this.curLanguage = this.styles[0].code;
            this.curStyle = 0;
            this.$emit('updated', {
                language: this.curLanguage,
                style: this.curStyle
            });
        },
        gotStyle(event) {
            console.log("gotStyle: " + event.target.value);
            this.curStyle = event.target.value;
            this.$emit('updated', {
                language: this.curLanguage,
                style: this.curStyle
            });
        },

    },
    created() {
        if (this.mysel) {
            this.sel = this.mysel;
            this.ulang = this.languages.filter(this.onlyUnique);
            this.ulang.unshift("All Languages");
            this.filterVoices("All Languages");
        };
        if (this.myVoice) {
            this.curVoice = this.myVoice;
            this.lang = "English (United States)";
            this.styles = this.newVoices[this.lang];
            this.curStyle = 0;
            this.curLanguage = this.styles[0].code;
        }
    },
    mounted() {},

}
</script>

<style scoped lang="scss">
</style>
